import { gql } from '@apollo/client';
const RESET_CONVERSATION_UNREAD_COUNT = gql `
  mutation ResetConversationUnreadCount($conversationId: ID!) {
    resetConversationUnreadCount(conversationId: $conversationId)
  }
`;
export default RESET_CONVERSATION_UNREAD_COUNT;
